import { client } from "@lib/api"
import useSWR from "swr"

export type BalanceResponse = {
    confirmed_balance: number | 'unavailable'
    legacy_balance: number | 'unavailable'
    new_balance: number | 'unavailable'
}

export type Balance = {
    confirmed_balance: number | 'unavailable'
    legacy_balance: number | 'unavailable'
    new_balance: number | 'unavailable'
}

const useBalance = () => {
    const { data, error, isLoading } = useSWR<Balance>('/wallet/balance', async (url: string): Promise<Balance> => {
        try {
            const response = await client.doGet<BalanceResponse>(url)
            return {
                confirmed_balance: response.confirmed_balance,
                legacy_balance: response.legacy_balance,
                new_balance: response.new_balance
            }
        } catch (error) {
            return {
                confirmed_balance: 'unavailable',
                legacy_balance: 'unavailable',
                new_balance: 'unavailable',
            }
        }
    }, {
        revalidateOnFocus: true,
        revalidateOnReconnect: true
    })

    return {
        data,
        isLoading,
        error
    }
}

export default useBalance
